import React, { useCallback } from "react";
import clsx from "clsx";
import type { RefCallBack, UseFormRegister } from "react-hook-form";

import { Skeleton } from "components";

import styles from "./checkbox.module.scss";

type HookFormCheckboxProps = {
	register?: UseFormRegister<any>;
	className?: string;
	checked?: boolean;
	onChange?: React.ChangeEventHandler<HTMLInputElement>;
	blurLoading?: boolean;
	blurWidth?: string;
	blurHeight?: string;
	name: string;
	refController?: RefCallBack;
	id: string;
	defaultCheckedByValue?: boolean;
} & React.HTMLProps<HTMLInputElement>;

const HookFormCheckbox: React.FC<HookFormCheckboxProps> = ({
	register,
	label,
	id,
	checked,
	onChange,
	className,
	disabled,
	style,
	blurLoading = false,
	blurWidth = "200px",
	blurHeight = "20px",
	name,
	refController,
	defaultCheckedByValue = false,
	...props
}) => {
	const CheckboxWithLoader = useCallback(
		({ checkbox }) =>
			blurLoading ? (
				<Skeleton
					variant="text"
					width={blurWidth}
					maxWidth={blurWidth}
					height={blurHeight}
				/>
			) : (
				checkbox
			),
		[blurHeight, blurLoading, blurWidth],
	);

	const {
		onChange: formOnChange,
		onBlur,
		name: nameForm,
		ref: refRegister,
		...rest
	} = {
		...(register ? register(name) : {}),
	};

	const checkbox = (
		<div className={clsx(styles.wrappCheckButton, className)} style={style}>
			<input
				{...rest}
				onBlur={onBlur}
				name={nameForm}
				ref={refRegister || refController}
				type="checkbox"
				id={id}
				disabled={disabled}
				checked={checked}
				onClick={e => e.stopPropagation()}
				onChange={event => {
					formOnChange?.(event);
					onChange?.(event);
				}}
				defaultChecked={defaultCheckedByValue}
				{...props}
			/>
			{label && (
				<label htmlFor={id} className={styles.checkbox}>
					{label}
				</label>
			)}
		</div>
	);
	return <CheckboxWithLoader checkbox={checkbox} />;
};

export default HookFormCheckbox;
